import { createBrowserRouter, Navigate } from 'react-router';
import { Root, ProtectedDashboard, ProtectedContacts, ProtectedContactDetail, SignUpOrDashboard, NotFound } from './routes';

export const router = createBrowserRouter([
  {
    path: '/signup',
    Component: SignUpOrDashboard,
  },
  {
    path: '/',
    Component: Root,
    children: [
      { index: true, Component: () => <Navigate to="/signup" replace /> },
      { path: 'events', Component: ProtectedDashboard },
      { path: 'people', Component: ProtectedContacts },
      { path: 'people/:id', Component: ProtectedContactDetail },
      { path: '*', Component: NotFound },
    ],
  },
]);
